import { useBlocNext } from "@blac/react";
import { FC, useEffect } from "react";
import React from "react";
import MedicalInsuranceCardDetailsForm from "./MedicalInsuranceCardDetailsForm";
import MedicalInsuranceFormBloc, {
  AddMedicalInsuranceInfoAction
} from "./MedicalInsuranceFormBloc";
import MedicalInsuranceSelectHealthPlanForm from "./MedicalInsuranceSelectHealthPlanForm";
import MedicalInsuranceUploadPhoto from "./MedicalInsuranceUploadPhoto";
import MedicalInsuranceSubscriberInformationForm from "components/MedicalInsuranceForm/MedicalInsuranceSubscriberInformationForm";
import { TaskConfigAdditionalData } from "../TaskList/TaskListBloc";

const MedicalInsuranceForm: FC<{
  onStepChange: () => void;
  taskAdditionalData?: TaskConfigAdditionalData;
}> = (props) => {
  const [{ step }, { setInitialStep, setPhotoUploadCanBeSkippedByUser }] =
    useBlocNext(MedicalInsuranceFormBloc);

  useEffect(() => {
    setPhotoUploadCanBeSkippedByUser(
      props.taskAdditionalData?.photoUploadCanBeSkippedByUser ?? false
    );
  }, [props.taskAdditionalData]);

  useEffect(() => {
    props.onStepChange();
  }, [step]);

  useEffect(() => {
    setInitialStep();
  }, []);

  switch (step) {
    case AddMedicalInsuranceInfoAction.SELECT_HEALTH_PLAN:
      return <MedicalInsuranceSelectHealthPlanForm />;
    case AddMedicalInsuranceInfoAction.SUBSCRIBER_INFO:
      return <MedicalInsuranceSubscriberInformationForm />;
    case AddMedicalInsuranceInfoAction.ADD_CARD_DETAILS:
      return <MedicalInsuranceCardDetailsForm />;
    case AddMedicalInsuranceInfoAction.ADD_CARD_PHOTOS:
      return <MedicalInsuranceUploadPhoto />;
  }
};

export default MedicalInsuranceForm;
